import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { Button, Container, Card } from "react-bootstrap";
import Layout from "../../../../layout/default";
import { useParams } from "react-router-dom";

const UserAddressCheck = () => {
    const { id } = useParams();  // Get user_id from the URL params
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [address, setAddress] = useState(null);
    const [error, seterror] = useState('');

    useEffect(() => {
        const authToken = localStorage.getItem("authToken");
        if (authToken) {
            const fetchaddress = async () => {
                try {
                    setLoading(true);
                    const response = await axios
                        .get(`${process.env.REACT_APP_HOST}api/addres/getUserAddress`, {
                            headers: {
                                Authorization: `Bearer ${authToken}`,
                            },
                        });
                    debugger;
                    if (response.data.data) {
                        setAddress(response.data.data);
                    } else {
                        setAddress(null);
                    }
                    setLoading(false)
                } catch (err) {
                    console.error("Error fetching address:", err);
                    if (err.response && err.response.data.success === false) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'User Address Not Found',
                            text: 'We could not find your Details. Please add one.',
                        }).then(() => {
                            navigate("/shop/auths/add-user-address");
                        });
                    } else {
                        seterror("Failed to fetch address. Please try again.");
                    }
                }
            };
            fetchaddress();
        } else {
            setLoading(false);
            seterror('No auth token found. Please log in.');
            navigate("/shop/auths/login", { replace: true }); // Redirect to login page if no authToken
        }
    }, [navigate]); // Trigger effect on component mount

    const handleAddAddress = () => {
        navigate("/shop/auths/add-user-address");
    };

    const handleEdit = (id) => {
        if (id) {
            navigate(`/shop/auths/edit-address/${id}`);
        } else {
            seterror("No address found to edit.");
        }
    };
    return (
        <Layout title="User Address">
            <Container className="mt-4">
                <h3>User Address Details</h3>
                {address && address.length > 0 ? (
                    <Card className="p-3">
                        <div key={address[0].id} className="mb-3 border-bottom pb-2">
                            <p><strong>Shipping Address:</strong> {address[0].address}</p>
                            <p><strong>Phone Number:</strong> {address[0].phone_number}</p>
                            <p><strong>Pin code:</strong> {address[0].pin_code}</p>
                            <p><strong>State:</strong> {address[0].state_name}</p>
                            <p><strong>District:</strong> {address[0].district_name}</p>
                            <p><strong>City:</strong> {address[0].city_name}</p>
                            <p><strong>Zone:</strong> {address[0].zone_name}</p>
                            <Button
                                variant="primary"
                                className="mt-3"
                                onClick={() => handleEdit(address[0].id)} // Pass the correct id here
                            >
                                Edit User Address
                            </Button>
                        </div>
                    </Card>
                ) : (
                    <p>No addresses found.</p>
                )}


                {address && address.length > 0 ? (
                    <Card className="p-3">
                        <div key={address[0].id} className="mb-3 border-bottom pb-2">
                            <p><strong>Billing  Address:</strong> {address[0].address}</p>
                            <p><strong>Phone Number:</strong> {address[0].phone_number}</p>
                            <p><strong>Pin code:</strong> {address[0].pin_code}</p>
                            <p><strong>State:</strong> {address[0].state_name}</p>
                            <p><strong>District:</strong> {address[0].district_name}</p>
                            <p><strong>City:</strong> {address[0].city_name}</p>
                            <p><strong>Zone:</strong> {address[0].zone_name}</p>
                            <Button
                                variant="primary"
                                className="mt-3"
                                onClick={() => handleEdit(address[0].id)} // Pass the correct id here
                            >
                                Edit User Address
                            </Button>
                        </div>
                    </Card>
                ) : (
                    <p>No addresses found.</p>
                )}

            </Container>

            <br />
            <br />
            <br />
            <br />
        </Layout>
    );
};

export default UserAddressCheck;
